module.exports = __webpack_public_path__ + "static/media/profile-picture.67f33b07.jpg";